module.exports = __webpack_public_path__ + "img/20190808171819282.e044f7f7.png";